module.exports = __webpack_public_path__ + "img/filter.d9035b7b.svg";